<template>
  <div class="test pt-4">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h5>
            <div class="badge">Тест</div>
          </h5>
          <b-overlay
            :show="isLoading"
            variant="transparent"
            spinner-variant="primary"
          >
            <template v-if="!isLoading">
              <h3>{{ test.name }}</h3>
              <p>
                {{ test.description }}
              </p>
              <hr />
            </template>
            <template v-if="!isLoading && test.type == 'basic'">
              <basicTest ref="basic" :test="test" @finish="saveResult" />
            </template>
            <template v-if="!isLoading && test.type == 'logic'">
              <logicTest ref="logic" :test="test" @finish="saveResult" />
            </template>
            <template v-if="!isLoading && test.type == 'psycho'">
              <psychoTest ref="psycho" :test="test" @finish="saveResult" />
            </template>
          </b-overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import basicTest from "./test-types/basic-test.vue";
import logicTest from "./test-types/logic-test.vue";
import psychoTest from "./test-types/psycho-test.vue";
export default {
  components: {
    basicTest,
    logicTest,
    psychoTest,
  },
  data() {
    return {
      isLoading: false,
      test: {},
    };
  },
  computed: {},
  methods: {
    async fetchTest() {
      this.isLoading = true;
      let args = {
        collectionName: "tests",
        where: ["id", "==", Number(this.$route.params.id)],
      };
      let result = await this.$db.getCollection(args);
      this.test = result.docs[0];
      let type = this.test.type;
      setTimeout(() => {
        this.$refs[type].mapAnswers();
      }, 600);

      this.isLoading = false;
    },
    async saveResult(result) {
      result["user"] = this.$store.state.user.uid;
      result["user_id"] = this.$store.state.userData.id;
      result["test_id"] = this.test.id;
      result["test_name"] = this.test.name;
      let now = new Date();

      result["datetime"] = now;
      await this.$db.add("test_results", result);
      this.$toast.success("Результат тесту збережено");
    },
  },
  mounted() {
    this.fetchTest();
  },
};
</script>

<style lang="scss" scoped>
.badge {
  background: var(--primary-color);
}
</style>
